module.exports = __webpack_public_path__ + "img/8_25.d31cf303.png";